import LocalizedStrings from "react-localization";

let labels = new LocalizedStrings({
  en: {
    // Login
    login: {
      title: "RICC",
      titleDescription:
        "The Retirement Income Information Clearing & Calculation System",
      enterYourLoginInfo: "Enter Your Login Information",
      operatorId: "Operator ID",
      password: "Password",
      forgotOperatorId: "Forgot Operator ID",
      forgotPassword: "Forgot Password",
      logIn: "Log In",
      requestNewOperatorAccess: "Request New Operator Access",
      updateAccessLevel: "Change Password",
      cancel: "Cancel",
      passwordExpired: "Your password has been expired.",
      changePassword: "Change Password",
    },
    forgotPassword: {
      title: "Re-establish Password",
      setupAccount: "Complete Profile Setup",
      operatorId: "Operator ID:",
      updateAccessLevel: "Change Password",
      newPassword: "New Password *",
      confirmPassword: "Confirm Password *",
      passwordsMustMatch: "Passwords must match",
      save: "Save & Login",
      cancel: "Cancel",
      changePassword: "Change Password",
      enterPasswordTwice: "Enter your new password twice.",
    },
    forgotOperator: {
      email: "Email *",
      retrieveId: "Retrieve ID",
      search: "Search",
      cancel: "Cancel",
      goToLogin: "Go To Login",
      yourOperatorIs: "Your Operator ID is <strong>operatorId</strong>",
      retrieveOperatorId: "Retrieve Operator ID",
    },
    requestNewOperator: {
      sortbymanufacturer: "Sort by manufacturer",
      sortbycurrentaccesslevel: "Sort by current access level",
      requestNewAccess: "Request New Operator Access",
      sendRequest: "Send Request",
      cancel: "Cancel",
      goToLogin: "Go To Login",
      successMessage:
        "Your request has been submitted. You will receive an email notification upon approval with a link to complete profile setup.",
      accessOptions: "Access Options",
      yourInsuranceCompany: "Your Insurance Company *",
      productManufacturer: "Product Manufacturer",
      accessLevel: "Access Level",
      emailMustMatch: "Email Ids must match",
      contactInformation: "Contact Information",
      firstName: "First Name: *",
      middleName: "Middle Name:",
      lastName: "Last Name: *",
      addressLine1: "Address Line 1: *",
      addressLine2: "Address Line 2:",
      addressLine3: "Address Line 3:",
      city: "City: *",
      state: "State *",
      zip: "Zip Code: *",
      phone: "Phone: *",
      ext: "Ext:",
      cellPhone: "Cell Phone:",
      fax: "Fax:",
      email: "Email: *",
      confirmEmail: "Confirm Email: *",
      answerMustMatch: "Answer and Confirm Answer do not match",
      securityInfo: "Security Information",
      customOperatorId: "Custom Operator ID: *",
      chooseQuestions:
        "Choose and answer two personalized security questions. These will be used to validate your identity to complete setup and in the event that your ID and/or password become misplaced or disabled.",
      question1: "Personalized Security Question #1 *",
      question2: "Personalized Security Question #2 *",
      answer: "Answer *",
      confirmAnswer: "Confirm Answer :*",
      productManufacturerDoesNotExist: "No Product Manufacturers exist.",
      productDetail: {
        productDetails: "Product Details",
        externalProductId: "External Product ID",
        productName: "Product Name",
        productDescription: "Product Description",
        productType: "Product Type",
        productDistribution: "Product Distribution",
        productActivation: "Product Activation",
        activeDate: "Active Date",
        closeAt: "Close At",
        reopenAt: "Re-Open At",
        setUpCompletionDate: "Set Up Completion Date",
        newOwnerShipCloseDate: "New Owner Ship Close Date",
        newPurchaseCloseDate: "New Purchase Ship Close Date",
        next: "Next",
        cancel: "Cancel",
        viewProductDetails: "View Product Details",
        investmentVehicles: "Investment Vehicles",
      },
    },
    setupAccount: {
      alreadySetup: "The account has already been set up.",
      invalidOperator: "Invalid Operator ID",
    },
    navbar: {
      admin: "Admin",
      profile: "Profile",
      product: "Product",
      owner: "Owners",
      transactionMatrix: "Transaction Matrix",
      cancel: "Cancel",
      products: "Products",
      approveNewAccess: "Approve New Access Request",
      insuranceCompanies: "Insurance Companies",
      investmentVehicles: "Investment Vehicles",
      productManufacturer: "Product Manufacturers",
      recordKeeper: "Record Keeper",
      updateOperatorInformation: "Update Operator Information",
      yourProfile: "Profile",
      password: "Change Password",
      updateContactInfo: "Update Contact Information",
      updateAccessLevel: "Update Product Manufacturer List and Access Level",
      logout: "Logout",
      changeProductManufacturer: "Change Product Manufacturer",
    },

    // Profile
    changePassword: {
      title: "Change Password",
      passwordMatch: "New Password and Confirm Password must match.",
      heading: "Change the password you use to log in.",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      changePassword: "Change Password",
      continue: "Continue",
      success: "Password has been changed successfully.",
    },
    updateAccessLevel: {
      title: "Update Product Manufacturer List & Access Level",
      header: "Update Product Manufacturer List & Access Level",
      submit: "Once you submit an request, an email will be sent for approval.",
      continue: "Continue",
      cancel: "Cancel",
      sendRequest: "Send Request",
      success:
        "Your request has been submitted successfully & an email has been sent for approval.",
      accessOptions: "Access Options",
      sortBy: "Sort By",
      yourInsuranceCompany: "Your Insurance Company *",
      productManufacturer: "Product Manufacturer *",
      accessLevel: "New Access Level",
      currentAccessLevel: "Current Access Level",
      productManufacturerDoesNotExist: "No Product Manufacturers exist.",
    },
    updateContactInformation: {
      title: "Update Contact Information",
      done: "Done",
      cancel: "Cancel",
      success: "Your details have been updated successfully.",
      continue: "Continue",
      emailMustMatch: "Email Ids must match",
      contactInformation: "Contact Information",
      firstName: "First Name: *",
      middleName: "Middle Name:",
      lastName: "Last Name: *",
      addressLine1: "Address Line 1: *",
      addressLine2: "Address Line 2:",
      addressLine3: "Address Line 3:",
      city: "City: *",
      state: "State *",
      zip: "Zip Code: *",
      phone: "Phone: *",
      ext: "Ext:",
      cellPhone: "Cell Phone:",
      fax: "Fax:",
      email: "Email: *",
      confirmEmail: "Confirm Email: *",
      answerMustMatch: "Answer and Confirm Answer do not match",
      securityInfo: "Security Information",
      customOperatorId: "Custom Operator ID: *",
      chooseQuestions:
        "Choose and answer two personalized security questions. These will be used to validate your identity to complete setup and in the event that your ID and/or password become misplaced or disabled.",
      question1: "Personalized Security Question #1",
      question2: "Personalized Security Question #2",
      answer: "Answer *",
      confirmAnswer: "Confirm Answer :*",
      answerBoth: "Answer Both.",
    },

    // Admin
    approveNewAccessRequest: {
      title: "Approve New Access Request",
      approved: "approved",
      rejected: "rejected",
      operatorId: "Operator ID: *",
      search: "Search",
      continue: "Continue",
      cancel: "Cancel",
      reject: "Reject",
      approve: "Approve",
      requestHasBeen: "Your request has been",
      contactInformation: "Contact Information",
      phone: "Phone: ",
      ext: "Ext: ",
      cellPhone: "Cell Phone: ",
      fax: "Fax: ",
      noAccess: "No Access",
      profileInformation: "Profile Information",
      operator: "Operator ID: ",
      operatorIsRICCAdmin: "Operator is RICC Administrator",
      insuranceCompany: "Insurance Company: ",
      productManufacturer: "Product Manufacturer",
      accessLevel: "Access Level",
      currentAccessLevel: "Current Access Level",
      newAccessLevel: "New Access Level",
      productManufacturerDoesNotExist: "No Product Manufacturers exist.",
    },
    recordKeeper: {
      role: "Role",
      recordKeeper: "Record Keeper",
      contactFirstName: "First Name",
      contactLastName: "Last Name",
      contactPhone: "Phone",
      contactEmail: "Email",
      rkName: "Recordkeeper Name",
      rkTransmitterID: "Recordkeeper Transmitter ID",
      rkServerHost: "Server Host Name or IP Address",
      rkHostPort: "Host Port Number",
      rkSystem: "Record Keeping System",
      rkSystemMandatory: "Record Keeping System: *",
      title: "Record Keepers",
      addRK: "Add Recordkeeper",
      details: "View Details",
      addContact: "Add Contact",
      removeContact: "Remove",
      contacts: "Contacts",
      noContacts: "No Contacts",
      rkDetails: "Record Keeper Details",
      transmitterID: "Recordkeeper Transmitter ID:",
      name: "Name: *",
      cancel: "Cancel",
      update: "Update",
      submit: "Submit",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
      contactDetails: "Contact Details",
      firstName: "First Name: *",
      middleName: "Middle Name:",
      lastName: "Last Name: *",
      addressLine1: "Address Line 1: *",
      addressLine2: "Address Line 2:",
      addressLine3: "Address Line 3:",
      city: "City: *",
      state: "State",
      zip: "Zip Code: *",
      phone: "Phone: *",
      ext: "Ext:",
      cellPhone: "Cell Phone:",
      fax: "Fax:",
      email: "Email: *",
      contactInformation: "Contact Information",
      ok: "OK",
      contactRemove: "The contact will be removed. Do you want to proceed?",
      actions: "Actions",
    },
    productManufacturer: {
      noDataInvestmentVechile:
        "No investment vehicle has been specified for this Product Manufacturer. Add investment vehicles from the list above",
      noDataInvestmentInsurance:
        "No insurance company has been specified for this Product Manufacturer. Add insurance  companies from the list above",
      title: "Product Manufacturers",
      companyNameHeader: "Company Name",
      actions: "Actions",
      viewManufacturerDetails: "View Manufacturer Details",
      investmentVehicles: "Investment Vehicles",
      insuranceCompanies: "Insurance Companies",
      externalIdHeader: "External ID",
      role: "Role",
      contactFirstName: "First Name",
      contactLastName: "Last Name",
      contactPhone: "Phone",
      contactEmail: "Email",
      addManufacturer: "Add Manufacturer",
      removeContact: "Remove",
      addContact: "Add Contact",
      contacts: "Contacts",
      details: "View Details",
      name: "Name: *",
      cancel: "Cancel",
      update: "Update",
      submit: "Submit",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
      contactDetails: "Contact Details",
      firstName: "First Name: *",
      middleName: "Middle Name:",
      lastName: "Last Name: *",
      addressLine1: "Address Line 1: *",
      addressLine2: "Address Line 2:",
      addressLine3: "Address Line 3:",
      city: "City: *",
      state: "State",
      zip: "Zip Code: *",
      phone: "Phone: *",
      ext: "Ext:",
      cellPhone: "Cell Phone:",
      fax: "Fax:",
      email: "Email: *",
      adminEmail: "Administrator Email: *",
      confirmEmail: "Confirm Email: *",
      contactInformation: "Contact Information",
      externalId: "External Id: *",
      companyName: "Company Name: *",
      productManufacturerWebsite: "Product Manufacturer Website:",
      productManufacturerDetails: "Product Manufacturer Details",
      productManufacturer: "Product Manufacturer",
      emailMustMatch: "Email Ids must match",
      insuranceCompaniesFor: "Insurance Companies for ",
      filterByInsurance: "Filter By Insurance Company",
      add: "Add",
      insuranceCompany: "Insurance Company",
      remove: "Remove",
      insuranceError:
        "The insurance company is associated to a GI Product and cannot be removed.",
      date: "Date",
      insurerTransmitterID: "Insurer Transmitter ID",
      address: "Address",
      zipCodeHeader: "Zip Code",
      cityHeader: "City",
      investmentManagementCompanyHeader: "Investment Management Company",
      investmentVehicleHeader: "Investment Vehicle",
      extVehicleHeader: "External Vehicle ID",
      tradingSymbolHeader: "Trading Symbol",
      targetDateVehicleActivationHeader: "Target Date Vehicle Activation",
      investmentErrorMessage:
        "The vehicle is associated to a GI Product and cannot be removed.",
      investmentVehiclesFor: "Investment Vehicles for ",
      investmentManagementCompany: "Investment Management Company",
      noContacts: "No Contacts",
      insuranceCompanyCancelMessage:
        "Changes for the Product Manufacturer Insurance Company page have not been saved. Do you want to continue?",
      investmentVehicleCancelMessage:
        "Changes for the Product Manufacturer Investment Vehicle page have not been saved. Do you want to continue?",
      ok: "OK",
      contactRemove: "The contact will be removed. Do you want to proceed?",
    },
    updateOperatorInformation: {
      close: "Close",

      title: "Operator Information",
      contactInformation: "Contact Information",
      phone: "Phone: ",
      ext: "Ext: ",
      cellPhone: "Cell Phone: ",
      fax: "Fax: ",
      noAccess: "No Access",
      profileInformation: "Profile Information",
      operator: "Operator ID: ",
      operatorIsRICCAdmin: "Operator is RICC Administrator",
      insuranceCompany: "Insurance Company: ",
      productManufacturer: "Product Manufacturer",
      accessLevel: "Access Level",
      currentAccessLevel: "Current Access Level",
      newAccessLevel: "New Access Level",
      productManufacturerDoesNotExist: "No Product Manufacturers exist.",
      searchBy: "Search By: *",
      lastName: "Last Name",
      firstName: "First Name",
      operatorId: "Operator ID",
      terminated: "Terminated",
      suspended: "Suspended",
      active: "Active",
      date: "Date",
      search: "Search",
      noMatchesFound: "No matches found with",
      lastNameSmall: " last name.",
      operatorIdSmall: " operator ID.",
      threeAttempts:
        "Three unsuccessful login attempts - ID access is disabled.",
      enable: "Enable",
      statusInfo: "Status Information",
      currentStatusEstablished: "Current Status Established On: ",
      status: "Status: ",
      cancel: "Cancel",
      done: "Done",
      operatorInfo: "Operator Information History",
      noHistory: "No history exists",
      continue: "Continue",
      successMsg: "The operator has been updated successfully.",
      show: "Show",
      hide: "Hide",
      operatorHistory: "Operator History",
      sortBy: "Sort By",
    },
    investmentVehicle: {
      title: "Investment Vehicles",
      managementCompanies: "Investment Management Companies",
      addCompany: "Add Company",
      details: "View Details",
      investmentVehicles: "Investment Vehicles",
      addVehicle: "Add Vehicle",
      noVehicles: "No investment vehicles exist.",
      statusHeader: "Status",
      vehicleNameHeader: "Vehicle Name",
      extVehicleHeader: "External Vehicle ID",
      tradingSymbolHeader: "Trading Symbol",
      targetVehicleActivationDateHeader: "Target Date Vehicle Activation Date",
      companyNameHeader: "Company Name",
      taxIdHeader: "Tax ID",
      managementCompanyDetails: "Investment Management Company Details",
      name: "Name *",
      taxId: "Tax ID *",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
      cancel: "Cancel",
      update: "Update",
      submit: "Submit",
      enable: "Enable",
      disabled: "Disabled",
      vehicleStatus: "Vehicle Status",
      investmentVehicleDetails: "Investment Vehicle Details",
      disableMessage:
        "Disabling investment vehicle will make it unavailable to associate to a product",
      extVehicleId: "External Vehicle ID *",
      tradingSymbol: "Trading Symbol",
      addDate: "Add Target Date Vehicle Activation Date",
      activationDate: "Target Date Vehicle Activation Date *",
      activationDateLabel: "Target Date Vehicle Activation Date",
      productManufacturer: "Product Manufacturer",
      productName: "Product Name",
      vehicleAssociateMsg:
        "The vehicle is associated with products.  The status can be changed once it is removed from all products.",
      viewAssociatedProducts: "View Associated Products",
      hideAssociatedProducts: "Hide Associated Products",
      actions: "Actions",
    },
    insuranceCompany: {
      title: "Insurance Companies",
      navHeader: "Insurance Company",
      companyNameHeader: "Company Name",
      insurerIdHeader: "Insurer Transmitter ID",
      serverHostNameHeader: "Server Host Name or IP Address",
      hostPortNumberHeader: "Host Port Number",
      role: "Role",
      contactFirstName: "First Name",
      contactLastName: "Last Name",
      contactPhone: "Phone",
      contactEmail: "Email",
      addInsuranceCompany: "Add Insurance Company",
      details: "Details",
      contacts: "Contacts",
      removeContact: "Remove",
      addContact: "Add Contact",
      noContacts: "No Contacts",
      insuranceCompanyDetails: "Insurance Company Details",
      contactDetails: "Contact Details",
      insurerId: "Insurer Transmitter ID:",
      firstName: "First Name: *",
      middleName: "Middle Name:",
      lastName: "Last Name: *",
      ext: "Ext:",
      cellPhone: "Cell Phone:",
      email: "Email: *",
      contactInformation: "Contact Information",
      companyName: "Company Name: *",
      addressLine1: "Address Line 1: *",
      addressLine2: "Address Line 2:",
      addressLine3: "Address Line 3:",
      city: "City: *",
      state: "State: *",
      zip: "Zip Code: *",
      phone: "Phone: *",
      fax: "Fax:",
      productManufacturerWebsite: "Insurance Company Website:",
      serverHostName: "Server Host Name or IP Address:",
      hostPortNumber: "Host Port Number:",
      cancel: "Cancel",
      done: "Done",
      update: "Update",
      submit: "Submit",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
      actions: "Actions",
      viewDetails: "View Details",
      ok: "OK",
      contactRemove: "The contact will be removed. Do you want to proceed?",
    },

    // Product
    productDetail: {
      navHeader: "Guaranteed Income Products",
      addProduct: "Add New Product",
      productDetails: "Product Details",
      externalProductId: "External Product ID",
      productName: "Product Name",
      productDescription: "Product Description",
      productType: "Product Type",
      productDistribution: "Product Distribution",
      productActivation: "Product Activation",
      activeDate: "Active Date",
      closeAt: "Close At",
      reopenAt: "Re-Open At",
      actions: "Actions",
      setUpCompletionDate: "Set Up Completion Date",
      newOwnerShipCloseDate: "New Owner Ship Close Date",
      newPurchaseCloseDate: "New Purchase Ship Close Date",
      next: "Next",
      cancel: "Cancel",
      viewProductDetails: "View Product Details",
      investmentVehicles: "Investment Vehicles",
      printProductDetails: "Print",
      status: "Status",
      setUp: "Set Up",
      externalId: "External Product ID",
      name: "Name",
      type: "Type",
      description: "Description",
      insuranceCoverageRate: "Insurance Companies",
      insuranceCompanies: "Insurance Companies",
      purchaseTables: "Purchase Tables",
      transactionMatrix: "Transaction Matrix",
      productRules: "Product Rules",
      duplicateProduct: "Duplicate Product",
      complete: "Complete",
      inComplete: "InComplete",
      paymentTable: "Payment Table",

      contractCertificate: "Contract & Certificate",
      continue: "Continue",
      duplicationMsg:
        "Product selected for duplication does not have all required fields completed. Do you want to continue?",
      purchaseTablePageFor: "Purchase Table for ",
      searchForPurchaseTable: "Search for Purchase Table",
      investmentVehicle: "Investment Vehicle",
      tableDate: "Table Date",
      search: "Search",
      purchaseTable: "Purchase Table",
      apply: "Apply",
      purchaseTableHistory: "Purchase Table History",
      age: "Age",
      price: "Price",
      date: "Date",
      operator: "Operator",
      selectInvestmentVehicleDate: "Select an Investment Vehicle & Table Date",
      noHistory: "No history exists",
      noExistingTable:
        "There is no existing table for this selected Investment Vehicle and/or date. ",
      importPurchaseTable: "Import Purchase Table",
      showPurchaseTableHistory: "Show Purchase Table History",
      more: "More",
      successMsg: "The purchase table has been updated successfully.",
      reset: "Reset",
    },
    productRules: {
      title: "Product Rules for ",
      notEstablished: "Product Rules have not been established",
      cancel: "Cancel",
      done: "Done",
      addProductRules: "Add Product Rules",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
    },
    productInsurer: {
      addCoverageRisk: "Add Coverage Risk",
      noAllInsuranceData:
        "An Insurance Company has not been associated to the Product Manufacturer. Contact RICC Support to add Insurance Companies",
      title: "Insurance Companies for ",
      noData:
        "No insurance company has been specified for this product. Add insurance  companies from the list above",
      selectInsurer:
        "Select an Insurance Company in the top table and use the Risk field to add a Risk level, to the bottom Insurance Coverage Risk table.",
      insuranceCompany: "Insurance Companies",
      filterByInsurance: "Filter By Insurance Company",
      add: "Add",
      riskCoverage: "Insurance Risk Coverage",
      remove: "Remove",
      coverageNeeded: "Coverage Needed",
      currentCoverage: "Current Coverage",
      submit: "Submit",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
      insurerTransmitterID: "Insurer Transmitter ID",
      address: "Address",
      zipCodeHeader: "Zip Code",
      cityHeader: "City",
      state: "State",
      riskPercentage: "Risk: *",
      addRemainderTo: "Add Remainder To",
      date: "Date",
      riskPercentageCannotBeGreater:
        "Risk percentage cannot be greater than 100",
      actions: "Actions",
      networkConfigError:
        "Network configuration must be entered before Insurance Company can be added. Contact customer support.",
    },
    paymentTable: {
      paymentTableHistory: "Payment Table History",
      paymentTableFor: "Payment Table for ",
      noHistory: "No history exists",
      more: "More",
      paymentTableSearch: "Payment Table Search",
      searchDate: "Search Date",
      search: "Search",
      reset: "Reset",
      newTableEffectiveDate: "New Table Effective Date",
      paymentTable: "Payment Table",
      importPaymentTable: "Import Payment Table",
      paymentRateTable: "Import Payment Rate Table",
      tableEffectiveDate: "Table Effective Date: ",
      auditHistory: "Audit History",
      show: "Show",
      hide: "Hide",
      searchOrImportPaymentTable: "Search or Import Payment Table",
      searchPaymentTable: "Search Payment Table",
      done: "Done",
      continue: "Continue",
      successMsg: "The payment table has been updated successfully.",
      csvError: "CSV validation error:",
      alreadyExists: "The payment table for the effective date already exists.",
      date: "Date",
      age: "Age",
      singleFactor: "Single Factor",
      operatorId: "Operator ID",
      ownerAge: "Owner Age",
      jointFactor: "Joint Factor",
      cRate: "C Rate",
      tRate: "T Rate",
      noPaymentTable: "No payment table exists",
      invalidFileError: "Upload failed. Only CSV files are allowed.",
    },
    purchaseTable: {
      csvImportError:
        "File selected for import does not contain all the required information.",
      invalidFileError: "Upload failed. Only CSV files are allowed.",
    },
    transactionTable: {
      recordKeeper: "Record Keeper",
      noRecordKeeper:
        "Product Investment Vehicles must be established in order to add a Transaction Matrix",
      noData:
        "There is no Transaction Matrix for this Recordkeeper. Import a Transaction file.",
      importTransactionTable: "Import Transaction Table",
      importTransactionFile: "Import a Transaction Matrix File",
      title: "Transaction Matrix",
      tableName: "Transaction Table",
      recordkeeper: "Recordkeeper *",
      rKCode: "R/K Code",
      rkDesc: "R/K Description",
      riccCode: "RICC Code",
      riccDescription: "RICC Description",
      balInd: "Bal Ind",
      affectBase: "Affect Base",
      origAccum: "Orig Accum",
      orugWithdrawal: "Orug Withdrawal",
      beneAccum: "Bene Accum",
      beneWithdrawal: "Bene Withdrawal",
      qDROAccum: "QDRO Accum",
      qDROWithdrawal: "QDRO Withdrawal",
      cancel: "Cancel",
      done: "Done",
      continueMessage: "Transaction Matrix has been updated successfully",
      continue: "Continue",
      changesUpdate:
        "Changes for the Transaction Matrix have not been saved. Do you want to continue?",
      invalidFileError: "Upload failed. Only CSV files are allowed.",
    },
    contractCertificate: {
      noData: "No plan have been associated to this product",
      title: "Contract and Certificate Number Processing for ",
      navHeader: "Contract and Certificate",
      pageHeader: "Contract and Certificate Number Processing Plan Details",
      details: "Details",
      planName: "Plan Name",
      planId: "Plan ID",
      recordKeeper: "Record Keeper",
      contractNumberHeader: "Contract Number",
      startingCertificateNumber: "Starting Certificate Number",
      stateOfIssue: "State of Issue",
      planType: "Plan Type",
      planEnd: "Plan Year End",
      lob: "Plan LOB",
      deferral: "Deferral Plan ID",
      deferralLOB: "Deferral Plan LOB",
      contractNumber: "Contract Number: *",
      certNumber: "Starting Certificate Number: *",
      certificateNumber: "Starting Certificate Number",
      submit: "Submit",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
      onceContractAdded:
        "Once Contract Number is added, this field cannot be changed.",
      onceCertAdded:
        "Once Certificate Number is saved, this field cannot be changed.",
      actions: "Actions",
      viewDetails: "View Details",
    },
    viewProductDetails: {
      title: "Product Details",
      continue: "Back To Product List",
      continueMessage: "Product Details have been updated successfully.",
      paymentTableUpdate:
        "Payment Table must be updated when the Payment Table Age Range has been changed.",
    },
    duplicateProduct: {
      title: "Product Details",
      continue: "Back To Product List",
      continueMessage: "Product Details have been copied successfully.",
    },
    addProduct: {
      title: "Add New Product",
      productOptions: "Product Options",
      continue: "Back To Product List",
      continueMessage: "Product has been added successfully.",
    },
    product: {
      externalIdDisplay:
        " External Product ID will display once Product Details are saved.",
      externalProductId: "External Product Id: ",
      productName: "Product Name *",
      description: "Product Description *",
      productType: "Product Type",
      productActivation: "Product Activation",
      activeDt: "Active Date",
      closeAt: "Close At",
      reopenAt: "Reopen At",
      newInvestorCloseDt: "New Ownership Close Date",
      newPurchaseCloseDt: "New Purchase Close Date",
      setupCompletionDate: "Setup Completion Date",
      ownerQualifications: "Owner Qualifications",
      entryAge: "Entry Age",
      minimum: "Minimum",
      maximum: "Maximum",
      withdrawalAge: "Withdrawal Age",
      eligibleYears: "Eligible Years",
      eligibility: "Eligible",
      months: "Months",
      mandatory: "Mandatory",
      minBenefitAmount: "Minimum Amount",
      maxBenefitAmount: "Maximum Amount",
      next: "Next",
      back: "Back",
      minPurchaseAmount: "Min Initial Purchase Amount",
      minAdditionalPurchaseAmount: "Min Additional Purchase Amount",
      maxTotalPurchaseAmount: "Max Total Purchase Amount",
      minPortfolioAmount: "Minimum Portfolio Balance Payout Trigger Amount",
      guaranteedAges: "Guaranteed Benefits Age",
      ownerEnquiry: "Owner Enquiry",
      incomeBase: "Income Base",
      schedules: "Schedules",
      purchaseTableAge: "Purchase Table Age Range (Years)",
      paymentTableAge: "Payment Table Age Range (Years)",
      lockoutDays: "Product Lockout Period (Days)",
      lockoutYears: "Minimum Funding Period (Years)",
      years: "Years",
      exchangeAge: "Exchange Restriction Age",
      maxBenefitReset: "Max Income Base Reset Age",
      contributionLimit: "Contribution Limit on Transfers and Rollovers",
      maxAmount: "Max Amount",
      per: "per",
      monthPeriod: "Month Period",
      allowableAgeDifference:
        "Allowable age Difference for Joint Annuitant (Years)",
      submit: "Submit",
      maintenanceRules: "Maintenance Rules",
      stepUp: "Step Up Age (Years)",
    },

    // Owner
    ownerInquiry: {
      noData:
        "No matches found with the last name , tax ID, participant ID or plan ID",
      title: "Owner Inquiry",
      searchTitle: "Owner Inquiry Search",
      searchBy: "Search By: *",
      firstName1: "First Name",
      firstName: "First Name *",
      middleName: "Middle Name:",
      lastName1: "Last Name",
      lastName: "Last Name *",
      taxId: "Tax ID",
      productName: "Product Name",
      ownershipType: "Ownership Type",
      participantId: "Participant ID",
      recordKeeper: "Record Keeper",
      planId: "Plan ID (optional)",
      search: "Search",
      searchAgain: "Search Again",
      reset: "Reset",
      done: "Done",
      ownerInquiryResults: "Owner Inquiry Results",
      printOwnerInquiryResults: "Print",
      ownerDetails: "Owner Details",
      name: "Name",
      street: "Street",
      city1: "City",
      city: "City *",
      state1: "State",
      state: "State *",
      stateCountry: "State/Country *",
      zip1: "Zip Code",
      zip: "Zip Code *",
      phone1: "Phone",
      phone: "Phone *",
      ext: "Ext.",
      email: "Email",
      dob: "Date of Birth",
      gender: "Gender",
      male: "Male",
      female: "Female",
      ownershipPhase: "Ownership Phase",
      maritalStatus: "Marital Status",
      employmentStatus: "Employment Status",
      enrollDate: "Enrollment Date",
      electionEligibility: "Election Eligibility",
      incomeBaseReset: "Income Base Reset",
      productDetails: "Product Details",
      moneySourceDetails: "Money Source Details",
      accountDetails: "Account Details",
      transactionDetails: "Transaction Details",
      productDetailsProductName: "Product Name: ",
      productDetailsPlanId: "Plan ID",
      productDetailsRecordKeeper: "Recordkeeper: ",
      currAccountValue: "Current Account Value",
      currPeriodGuaranteeValue: "Current Period Guarantee Value",
      withdrawalPeriod: "Withdrawal Period: ",
      guaranteedWithdrawalAmount: "Guaranteed Withdrawal Amount: ",
      guaranteedWithdrawalPercent: "Guaranteed Withdrawal Percent: ",
      amountWithdrawn: "Amount Withdrawn: ",
      remainingWithdrawalAmount: "Remaining Withdrawal Amount: ",
      excessWithdrawalAmount: "Excess Withdrawal Amount:",
      nextPeriodGuaranteeValue: "Next Period Guarantee Value",
      incomeBase: "Income Base: ",
      accountDetailsAccountValue: "Account Value: ",
      returnOfPremium: "Return of Premium:",
      returnOfPremiumDeathBenefit: "Return of Premium Death Benefit:",
      lifetimeConformingWithdrawals: "Lifetime Conforming Withdrawals:",
      lifetimeNonConformingWithdrawals: "Lifetime Non-Conforming Withdrawals:",
      asOfBalanceDate: "As-of-balance Date",
      asOfAccountValue: "As-of Account Value",
      noAccountValueExistForDateError:
        "No account values exist for the date selected",
      guaranteedWithdrawal: "Guaranteed Withdrawal",
      currMoneySourceTotals: "Current Money Source Totals",
      incomeShares: "Income Shares",
      cashOutValue: "Cash Out Value",
      employeePretax: "Employee Pretax",
      employerPretax: "Employer Pretax",
      employeeAftertax: "Employee Aftertax",
      total: "Total",
      tradeDateRange: "Trade Date Range: ",
      tradeDate: "Trade Date",
      postDate: "Post Date",
      fromDateCannotBeLaterThanTo: "From date cannot be later than To date.",
      dateRangeExceedError: "The date range should not exceed 1 year.",
      toDateCannotBeEarlierThanFrom:
        "To date cannot be earlier than From date.",
      investmentVehicle: "Investment Vehicle",
      description: "Description",
      amount: "Amount",
      noHistoryDateRange: "No history exists for this Trade Date Range",
      disclaimerTitle: "Guarantee Withdrawal Details",
      disclaimerContent:
        "These are estimates based on the participant's current age and income base. They assume 100% vesting, single benefit, and no future adjustments, withdrawals, or transfers that may reduce guarantees. Note that the Plan Document defines actual participant eligibility to take withdrawal transactions. Please review plan rules to determine participant eligibility for withdrawals.",
      last60Days: "Last 60 days",
      last90Days: "Last 90 days",
      yearToDate: "Year to date",
      previousYear: "Previous year",
      custom: "Custom",
      projections: "Projections",
      editProjections: "Edit Projections",
      removeProjection: "Remove Projection",
      updateSpouse: "Update Spousal Details",
      ownerRetirementAge: "Owner Retirement Age",
      elect: "Elect",
      singleBenefit: "Single Benefit",
      spousalBenefit: "Spousal Benefit",
      printTable: "Print Table",
      projectionModalHeading:
        "Add Projection and/or Spouse Date of Birth Information",
      projectionModalAgeLabel: "Add projected age of owner at retirement:",
      projectionModalDobLabel: "Add spouse's date of birth:",
      projectionAgeError: "Projected age must be greater than current age.",
      guaranteedProjections: "Guaranteed Projections and Election",
      cancel: "Cancel",
      submit: "Submit",
      confirm: "Confirm",
      spousalModalHeading: "Spousal Details",
      birthDate: "Birth Date",
      addressSameAsOwner: "Address same as owner",
      addressLine1: "Address Line 1: *",
      addressLine2: "Address Line 2:",
      addressLine3: "Address Line 3:",
      spousalGender: "Spousal Gender *",
      civilUnion: "Civil Union",
      firstYearWithdrawalAmount: "First Year Withdrawal Amount",
      electionType: "Election Type",
      ownerDateOfBirth: "Owner Date of Birth",
      spouseDateOfBirth: "Spouse Date of Birth",
      withdrawalElectionConfirmation: "Withdrawal Election Confirmation",
      accValueByVehicle: "Account Value by Vehicle Current Date",
      tradingSymbol: "Trading Symbol",
      vehicleValue: "Vehicle Value",
      tdf: "TDF Y/N",
      active: "Active Y/N",
      activationDate: "Activation Date",
      asOfCloseOfBusiness: "as of close of business",
      withdrawalElectionType: "Withdrawal Election Type",
      withdrawalElectionDate: "Withdrawal Election Date",
      restrictionEndDate: "Restriction End Date",
      guaranteedBenefitsAge: "Guaranteed Benefits at Age",
      guaranteedMonthlyIncome: "Guaranteed Monthly Income",
      sharePrice: "Share Price",
      noOfIncomeShares: "Number of Income Shares",
      zipCodeHeader: "Zip Code",
      cancelElectionToWithdraw: "Cancel Election to Withdraw",
      withdrawalElectionCancellation: "Withdrawal Election Cancellation",
      withdrawalElectionCancellationMessage:
        "You are about to cancel an Election to Withdraw. Select Done to complete your request.",
      electionToWithdrawPending: "Election to Withdraw Pending",
      annually: " annually",
    },
    productInvestmentVehicle: {
      vehicleStatus: "Vehicle Status",
      nameInvest: "Name",

      operator: "Operator",
      noAllVehicleData:
        "An Investment vehicle has not been associated to the Product Manufacturer. Contact RICC Support to add Investment vehicle",
      noData:
        "No investment vehicle has been specified for this product. Add investment vehicles from the list above",
      headerName: "Investment Vehicles",
      investmentManagementCompany: "Investment Management Company",
      name: "Investment Vehicle",
      externalId: "External Investment Vehicle Id",
      tradingSymbol: "Trading Symbol",
      targetFundActivationDate: "Target Date Vehicle Activation Date",
      externalVehicleId: "External Vehicle ID *",
      externalVehicleIdHeader: "External Vehicle ID",
      allCompanies: "All Companies",
      recordKeeper: "Record Keeper *",
      invVehiclesRK: "Investment Vehicle with Record Keepers :",
      cancel: "Cancel",
      investmentVehicleName: "Investment Vehicle",
      recordKeeperGrid: "Record Keeper",
      date: "Date",
      viewHistory: "Investment Vehicle History",
      delete: "Delete Selected",
      recordKeeperForInvestmentVehicleHistory: "Record Keeper",
      operatorID: "Operator ID",
      activeDate: "Active Date",
      closedDate: "Closed Date",
      investmentVehicleHistory: "Investment Vehicles History",
      noVehiclesHistory: "No History found",
      save: "Save",
      networkConfigErrorMessage:
        "Network configuration must be entered before Recordkeeper can be added. Contact customer support.",
      missingInvestmentVehicleInfo:
        "The Investment Vehicle information cannot be added.  Some of the required information is missing or needs to be corrected.",
      duplicateInvestmentVehicleAddMessage:
        "Duplicate Investment Vehicles cannot be added to the same Guaranteed Income product.",
      duplicateExternalVehErrorMessage:
        "Duplicate External Vehicle ID cannot be added.",
      noHistory: "No history exists",
      showAsterisk: "*",
      externalVehicleIdForHistory: "External Vehicle ID",
      deleteVehiclesText: "Delete Selected",
      addNewVehicle: "Add",
      investmentVehiclesFor: "Investment Vehicles for ",
      show: "Show",
      hide: "Hide",
      auditHistory: "Audit History",
      more: "More",
      invHistory: "Investment Vehicles History",
      cancelMessage:
        "Changes for the Investment Vehicle page have not been saved. Do you want to continue?",
      selectInvCompanyMsg:
        "Select an Investment Management Company in the top table and use the Recordkeeper dropdown to select a Recordkeeper, enter an External Vehicle ID and add Recordkeeper to bottom table.",
      invVehicleFor: "Investment Vehicles for",
      remove: "Remove",
      submit: "Submit",
      continue: "Continue",
      requestCompleted: "Your request has been completed.",
      duplicateExternalIdMsg: "Duplicate External Vehicle ID cannot be added.",
      duplicateInvMsg:
        "Duplicate Investment Vehicles cannot be added to the same Guaranteed Income product.",
      rkConfigMsg:
        "Network configuration must be entered before Recordkeeper can be added. Contact customer support.",
      removeMsg: "The vehicle has associated accounts and cannot be removed.",
    },
    sessionPopup: {
      expired: "Session Expired!",
      inactive: "Session Inactive!",
      continue: "Continue",
      logout: "Logout",
      expiryAlert:
        "Your session is going to expire. Click on continue if you want to extend the session.",
      inactiveAlert:
        "You have been inactive from the last few minutes. Click on continue to resume the session.",
    },
  },
});

export default labels;
